import { useCallback, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { Identifier } from "react-admin";
import { useDialog } from "./useDialog";

export const useStudentDunningDialog = () => {
  const [studentId, setStudentId] = useState<Identifier>("");
  const dunningDialog = useDialog();
  const { pathname, search } = useLocation();
  const navigate = useNavigate();

  const openDialog = useCallback(
    (studentId: Identifier) => {
      setStudentId(studentId);
      dunningDialog.openDialog();
      navigate({ pathname: "invoices", search });
    },
    [dunningDialog.openDialog, navigate, search],
  );

  const onClose = useCallback(() => {
    setStudentId("");
    dunningDialog.dialogProps.onClose();
    // Clean the URL from student bookedQuoteId and active tab path in the URL.
    navigate({ pathname: pathname.slice(0, pathname.indexOf("/dunning") + "/dunning".length), search });
  }, [dunningDialog.dialogProps.onClose, navigate, pathname, search]);

  return { dialogProps: { ...dunningDialog.dialogProps, onClose, studentId }, openDialog };
};
